import { Slider } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function SliderDemo() {
  return (
    <Section
      id="slider"
      title="Slider"
      description="Range input. Single or multi-thumb (one thumb per value)."
    >
      <VariantBlock label="Single thumb">
        <div className="w-80">
          <Slider defaultValue={[40]} max={100} step={1} />
        </div>
      </VariantBlock>

      <VariantBlock label="Multi-thumb (range)">
        <div className="w-80">
          <Slider defaultValue={[25, 75]} max={100} step={1} />
        </div>
      </VariantBlock>

      <VariantBlock label="Disabled">
        <div className="w-80">
          <Slider defaultValue={[50]} max={100} disabled />
        </div>
      </VariantBlock>

      <VariantBlock label="Vertical orientation">
        <Slider
          orientation="vertical"
          defaultValue={[30]}
          max={100}
          className="h-48"
        />
      </VariantBlock>
    </Section>
  );
}
